import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '@app/core/config/config.service';
import { AuthService } from '@app/core/guards/auth.service';
import { HttpService } from '@app/core/http/http.service';
import * as _ from 'lodash';
import { SearchParam } from '../models/datawell/searchParam.model';
import { Lot } from '../models/datawell/lot.model';
import { Operation } from '../models/datawell/operation.model';
import { Commande } from '../models/datawell/commande.model';
import { Marche } from '../models/datawell/marche.model';
import { SearchGlobalParam } from '../models/datawell/searchGlobalParam.model';
import { Tier } from '../models/datawell/tier.model';
import { Delegations } from '../models/datawell/delegations.model';
import { Avenant } from '../models/datawell/avenant.model';
import { Intervenants } from '../models/datawell/intervenants.model';
import { AvancementMarche } from '../models/datawell/avancement-marche';
import { AvancementAvenant } from '../models/datawell/avancement-avenant';

@Injectable({
  providedIn: 'root',
})
export class DatawellService extends HttpService {
  constructor(
    protected http: HttpClient,
    protected config: ConfigService,
    protected authService: AuthService
  ) {
    super(http, config, authService, 'datawell');
  }

  //#region Operation
  getOperationById(id: string): Observable<Operation> {
    return this.invokeGet<Operation>(`operation/${id}`);
  }

  searchOperation(searchParam: SearchParam[]): Observable<Operation[]> {
    return this.invokePost(searchParam, 'operation/search');
  }

  searchOperationWithGlobalParam(
    searchGlobalParam: SearchGlobalParam
  ): Observable<Operation[]> {
    return this.invokePost(
      searchGlobalParam,
      'operation/searchWithGlobalParam'
    );
  }

  //#endregion

  //#region Lot
  getLotById(id: string): Observable<Lot> {
    return this.invokeGet<Lot>(`lot/${id}`);
  }

  searchLot(searchParam: SearchParam[]): Observable<Lot[]> {
    return this.invokePost(searchParam, `lot/search`);
  }

  searchLotWithGlobalParam(
    searchGlobalParam: SearchGlobalParam
  ): Observable<Lot[]> {
    return this.invokePost(searchGlobalParam, 'lot/searchWithGlobalParam');
  }
  //#endregion

  //#region Commande
  getCommandeById(id: string): Observable<Commande> {
    return this.invokeGet<Commande>(`commande/${id}`);
  }

  searchCommande(searchParam: SearchParam[]): Observable<Commande[]> {
    return this.invokePost(searchParam, `commande/search`);
  }

  searchCommandeWithGlobalParam(
    searchGlobalParam: SearchGlobalParam
  ): Observable<Commande[]> {
    return this.invokePost(searchGlobalParam, 'commande/searchWithGlobalParam');
  }
  //#endregion

  //#region  Marche
  getMarcheById(id: string): Observable<Marche> {
    return this.invokeGet<Marche>(`marche/${id}`);
  }

  searchMarche(searchParam: SearchParam[]): Observable<Marche[]> {
    return this.invokePost(searchParam, `marche/search`);
  }

  searchMarcheWithGlobalParam(
    searchGlobalParam: SearchGlobalParam
  ): Observable<Marche[]> {
    return this.invokePost(searchGlobalParam, 'marche/searchWithGlobalParam');
  }
  //#endregion

  //#region  Tiers
  getTierById(id: string): Observable<Tier> {
    return this.invokeGet<Tier>(`tier/${id}`);
  }

  searchTier(searchParam: SearchParam[]): Observable<Tier[]> {
    return this.invokePost(searchParam, `tier/search`);
  }

  searchTierWithGlobalParam(
    searchGlobalParam: SearchGlobalParam
  ): Observable<Tier[]> {
    return this.invokePost(searchGlobalParam, 'tier/searchWithGlobalParam');
  }
  //#endregion

  //#region Delegations
  getDelegationsById(id: string): Observable<Delegations> {
    return this.invokeGet<any>(`delegations/${id}`);
  }
  //#endregion

  //#region Avenant
  getAvenantById(id: string): Observable<Avenant> {
    return this.invokeGet<any>(`avenant/${id}`);
  }

  searchAvenantWithGlobalParam(
    searchGlobalParam: SearchGlobalParam
  ): Observable<Avenant[]> {
    return this.invokePost(searchGlobalParam, 'avenant/searchWithGlobalParam');
  }
  //#endregion

  //#region Intervenants
  getIntervenantsById(id: string): Observable<Intervenants> {
    return this.invokeGet<any>(`intervenants/${id}`);
  }

  searchIntervenantsWithGlobalParam(
    searchGlobalParam: SearchGlobalParam
  ): Observable<Intervenants[]> {
    return this.invokePost(
      searchGlobalParam,
      'intervenants/searchWithGlobalParam'
    );
  }
  //#endregion

  //#region AvancementMarches
  getAvancementMarchesById(id: string): Observable<AvancementMarche> {
    return this.invokeGet<any>(`avancement_marche/${id}`);
  }

  searchAvancementMarchesWithGlobalParam(
    searchGlobalParam: SearchGlobalParam
  ): Observable<AvancementMarche[]> {
    return this.invokePost(
      searchGlobalParam,
      'avancement_marche/searchWithGlobalParam'
    );
  }
  //#endregion

  //#region AvancementAvenant
  getAvancementAvenantsById(id: string): Observable<AvancementAvenant> {
    return this.invokeGet<any>(`avancement_avenant/${id}`);
  }

  searchAvancementAvenantsWithGlobalParam(
    searchGlobalParam: SearchGlobalParam
  ): Observable<AvancementAvenant[]> {
    return this.invokePost(
      searchGlobalParam,
      'avancement_avenant/searchWithGlobalParam'
    );
  }
  //#endregion
}
